import React from "react";
import { RefreshCwIcon, MapIcon, ClipboardListIcon, TimerIcon, BookOpenIcon, BoxIcon } from "lucide-react";
import { tools } from "../data/content";
import { CtaButton } from "./CtaButton";
const iconMap: Record<(typeof tools)[number]["icon"], BoxIcon> = {
  loop: RefreshCwIcon,
  map: MapIcon,
  tracker: ClipboardListIcon,
  timer: TimerIcon,
  journal: BookOpenIcon
};
export function ToolsSection() {
  return <section className="w-full bg-ink px-5 py-16 text-white sm:py-20" data-id="element-293" data-mp="2vt5qi2xiibs5">
      <div className="mx-auto max-w-4xl" data-id="element-294" data-mp="2qtb000hnfo7m">
        <h2 className="text-center font-serif text-[30px] font-black leading-tight sm:text-5xl" data-id="element-295" data-mp="2qucjmtcqdj0y">
          Plus, you’ll get <em className="text-gold" data-id="element-296" data-mp="34u3y0v75t1fh">immediate access</em> to:
        </h2>

        <ul className="mt-10 divide-y divide-white/10 border-y border-white/10" data-id="element-297" data-mp="2zsy1sneaiw17">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 py-5" data-id="element-298" data-mp="f3icjwupzfdo">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal/15 text-teal" data-id="element-299" data-mp="f38nqcleve9k">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-300" data-mp="2i8eizye0tab3" />
                </span>
                <div data-id="element-301" data-mp="2m9qcwg3xghp3">
                  <h3 className="text-lg font-bold text-white" data-id="element-302" data-mp="2r6qhsnp1jeem">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-303" data-mp="2r4nifd2008x8">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-lg leading-relaxed text-white/80" data-id="element-304" data-mp="1yiuf92csis9x">
          Whatever stage you’re currently at, you’ll have a structured system to help you understand what you’re practicing, why you’re practicing it, and what to do next.
        </p>

        <div className="mt-10" data-id="element-305" data-mp="2d6p9woacz6pn">
          <CtaButton label="I want access to the complete system" data-id="element-306" data-mp="2d7qvvnswxdm5" />
        </div>
      </div>
    </section>;
}